export var ConnectionParams;
(function (ConnectionParams) {
    ConnectionParams["googleClientID"] = "integration/id/google";
    ConnectionParams["googleClientSecret"] = "integration/secret/google";
    ConnectionParams["googleSheetsImportClientID"] = "integration/id/gsheets-import";
    ConnectionParams["googleSheetsImportClientSecret"] = "integration/secret/gsheets-import";
    ConnectionParams["googleSheetsExportClientID"] = "integration/id/gsheets-export";
    ConnectionParams["googleSheetsExportClientSecret"] = "integration/secret/gsheets-export";
    ConnectionParams["googleAdWordsDevToken"] = "integration/secret/google-adwords";
    ConnectionParams["shopifyClientID"] = "integration/id/shopify";
    ConnectionParams["shopifyClientSecret"] = "integration/secret/shopify";
    ConnectionParams["salesforceClientID"] = "integration/id/salesforce";
    ConnectionParams["salesforceClientSecret"] = "integration/secret/salesforce";
    ConnectionParams["hubspotClientID"] = "integration/id/hubspot";
    ConnectionParams["hubspotClientSecret"] = "integration/secret/hubspot";
    ConnectionParams["hubspotImportAccessScopes"] = "integration/import_access_scopes/hubspot";
    ConnectionParams["dynamicsClientID"] = "integration/id/dynamics";
    ConnectionParams["dynamicsClientSecret"] = "integration/secret/dynamics";
    ConnectionParams["stripePublicApiKey"] = "integration/stripe/publicApiKey";
    ConnectionParams["stripeWebhookSecret"] = "integration/stripe/webhook-secret";
    ConnectionParams["powerbiClientID"] = "integration/id/powerbi";
    ConnectionParams["powerbiClientSecret"] = "integration/secret/powerbi";
    ConnectionParams["tqpUrl"] = "integration/tqp/url";
    ConnectionParams["avalaraUsername"] = "integration/avalara/username";
    ConnectionParams["avalaraPassword"] = "integration/avalara/password";
    ConnectionParams["hubspotAppSecret"] = "integration/hubspot/appSecret";
    ConnectionParams["onedriveClientID"] = "integration/id/onedrive";
    ConnectionParams["onedriveClientSecret"] = "integration/secret/onedrive";
    ConnectionParams["onedriveExportClientID"] = "integration/id/onedrive-export";
    ConnectionParams["onedriveExportClientSecret"] = "integration/secret/onedrive-export";
})(ConnectionParams || (ConnectionParams = {}));
export const SFTP_CLIENT_TIMEOUT = 3000;
export const SFTP_CLIENT_RETRIES = 1;
export const SFTP_RETRY_MIN_TIMEOUT = 2000;
//# sourceMappingURL=connectionParams.js.map